export function getCurrentTimestamp() {
    return new Date().toISOString();
}
//# sourceMappingURL=getCurrentTimestamp.js.map